import React, { Component } from "react";

export default class Convenios extends Component {
  render() {
    return <div>Convenios</div>;
  }
}
